// Shared mapping between UI rate, WebAudio playbackRate, and Rubber Band params
// Rubber Band semantics:
// - time_ratio (tempo) = output_duration / input_duration
//   e.g., to slow to 0.8×, time_ratio must be 1 / 0.8 = 1.25 (stretch)
// Policy:
// - Not maintainPitch: WebAudio rate=r, RB tempo=1.0, RB pitch=1.0
// - MaintainPitch and r < ~1: WebAudio rate=1.0, RB tempo=1/r (stretch), RB pitch=1.0
// - MaintainPitch and r > ~1: WebAudio rate=r (compress via WA), RB tempo=1.0, RB pitch=1/r (pitch-correct)

export type SpeedMapping = {
  webAudioRate: number;
  rbTempo: number;  // Rubber Band time_ratio
  rbPitch: number;  // Rubber Band pitch_scale
};

export function computeSpeedMapping(rate: number, maintainPitch: boolean): SpeedMapping {
  const r = Math.max(0.0001, rate || 1);
  const eps = 1e-3;
  if (!maintainPitch) {
    return { webAudioRate: r, rbTempo: 1.0, rbPitch: 1.0 };
  }
  if (r < 1.0 - eps) {
    // SLOWER: WebAudio stays 1×, RB stretches (time_ratio = 1/r)
    return { webAudioRate: 1.0, rbTempo: 1 / r, rbPitch: 1.0 };
  } else if (r > 1.0 + eps) {
    // FASTER: WebAudio speeds up, RB fixes pitch (pitch_scale = 1/r)
    return { webAudioRate: r, rbTempo: 1.0, rbPitch: 1 / r };
  } else {
    // ~1×: keep everything neutral
    return { webAudioRate: 1.0, rbTempo: 1.0, rbPitch: 1.0 };
  }
}
